module.exports = __webpack_public_path__ + "static/media/color-wheel.233ad67a.png";